import * as React from 'react';
import b_ from 'b_';
import Modal, { Props as ModalProps } from 'shared/components/Modal';
import PulseLoading from 'shared/components/PulseLoading';
import { Content } from './components/Content';

import './index.scss';

interface Props extends ModalProps {
  footer: React.ReactNode;
  isLoading: boolean;
}

const b = b_.with('position-details-modal');

export const PositionDetailModalView: React.FC<Props> = ({
  isLoading,
  children,
  footer,
  ...props
}) => {
  return (
    <Modal className={b()} {...props}>
      {isLoading ? <PulseLoading /> : <Content footer={footer}>{children}</Content>}
    </Modal>
  );
};
